var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[(_vm.label)?_c('span',{staticClass:"dt-label mr-1"},[_vm._v(_vm._s(_vm.label)+":")]):_vm._e(),_c('span',[_vm._v(" "+_vm._s(_vm.formatedDate)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }